// frontend/src/features/production/serialization/components/GenealogyTree.tsx
//
// Recursively renders a GenealogyNode (either the frozen snapshot JSON, or
// the live-computed tree from the API — both have the exact same shape,
// see ADR-104 Rule SN-11 / SerializationService._walk_genealogy).

import type { GenealogyNode } from "../api/serializationApi";

interface GenealogyTreeProps {
  node: GenealogyNode;
  depth?: number;
}

const SOURCE_MODE_LABELS: Record<string, string> = {
  at_lot_intake: "ورود به انبار",
  during_production: "حین تولید",
  at_completion: "پایان تولید",
};

export function GenealogyTree({ node, depth = 0 }: GenealogyTreeProps) {
  return (
    <div style={{ marginInlineStart: depth > 0 ? "1.5rem" : 0 }}>
      <div
        className="glass-panel"
        style={{
          padding: "0.75rem 1rem",
          marginBottom: "0.5rem",
          borderInlineStart: depth > 0 ? "3px solid #94a3b8" : undefined,
        }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <strong dir="ltr">{node.serial_number}</strong>
          <span style={{ fontSize: "0.75rem", color: "#64748b" }}>
            {SOURCE_MODE_LABELS[node.source_mode] ?? node.source_mode}
          </span>
        </div>
        {node.lot_numbers.length > 0 && (
          <div style={{ fontSize: "0.8rem", marginTop: "0.35rem", color: "#475569" }}>
            پالت‌ها:{" "}
            {node.lot_numbers.map((ln, i) => (
              <span key={ln}>
                <span dir="ltr">{ln}</span>
                {i < node.lot_numbers.length - 1 ? "، " : ""}
              </span>
            ))}
          </div>
        )}
      </div>
      {node.components.length > 0 && (
        <div>
          {node.components.map((child) => (
            <GenealogyTree key={child.serial_number} node={child} depth={depth + 1} />
          ))}
        </div>
      )}
    </div>
  );
}
